/**
 * Enum for the result of a tile click. Used internally by the frontend to decide what to show to the user.
 */
export enum TileClickStatus {
  Success = 'Success',
  WrongCountry = 'WrongCountry',
  ProjectClosed = 'ProjectClosed',
  OverQuota = 'OverQuota',
  NotQualified = 'NotQualified',
  DynamicProfiler = 'DynamicProfiler',
}
